import { DocumentNode, gql } from '@apollo/client'

export const GET_VERSION: DocumentNode = gql`
    query GetVersion {
        version
    }
`
